import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import posthog from 'posthog-js'
import { initSentry } from './lib/sentry'
import { installerReseauNatif } from './lib/reseauNatif'
import { Capacitor } from '@capacitor/core'

import App from './App'
import './index.css'

// 🔴 PREMIÈRE INSTRUCTION EXÉCUTÉE du module, avant Sentry, PostHog et tout rendu :
// une requête interne partie avant cette ligne viserait la coquille elle-même (404).
// ⚠️ « Premier » au sens du CODE : les modules importés ci-dessus sont évalués avant,
// par construction. Ils ne lancent aucune requête au chargement — `initSentry` et
// PostHog s'initialisent plus bas, par appel explicite. Si l'un d'eux se mettait un
// jour à appeler le réseau dès son import, il échapperait à cette installation.
// Sans effet sur le web (aucune base d'API définie → sortie immédiate).
installerReseauNatif()

// Reader-app (Guideline 3.1.1/3.1.3(b) Apple) : dans le shell natif, on ne veut
// AUCUN Service Worker. Un SW hérité d'une session antérieure pourrait servir au
// reviewer une version web mise en cache AVANT le retrait des mentions de prix.
// → on désenregistre tout SW et on purge les caches au démarrage natif.
if (Capacitor.isNativePlatform()) {
  try {
    navigator.serviceWorker?.getRegistrations?.().then((regs) => {
      regs.forEach((r) => r.unregister())
    })
    if (typeof caches !== 'undefined') {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)))
    }
  } catch { /* API SW indispo — non bloquant */ }
}

initSentry()

try {
  const phKey = import.meta.env.VITE_POSTHOG_KEY
  if (phKey) {
    posthog.init(phKey, {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
      capture_pageview: true,
      autocapture: true,
      person_profiles: 'identified_only',
    })
  }
} catch (err) {
  console.error('[posthog] init failed', err)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
